import type { AnyValue } from "@/lib/rowTypes";
import { supabase } from "@/integrations/supabase/client";
import type { LearningEventInput } from "./types";

/**
 * Records a learning event via the engine-owned RPC. Failures are logged
 * but never thrown — event logging must not break progression flows.
 */
export async function recordLearningEvent(input: LearningEventInput): Promise<void> {
  try {
    const { data: userRes, error: userErr } = await supabase.auth.getUser();
    if (userErr || !userRes?.user) return;

    const { error } = await (supabase).rpc("record_learning_event", {
      p_event_type: input.eventType,
      p_module_key: input.moduleKey ?? null,
      p_lesson_id: input.lessonId ?? null,
      p_event_source: input.eventSource ?? "frontend",
      p_metadata: (input.metadata ?? {}) as AnyValue,
      p_correctness: input.correctness ?? null,
      p_idempotency_key: input.idempotencyKey ?? null,
    });
    if (error) console.warn("[learning-engine] record_learning_event failed", error);
  } catch (err) {
    console.warn("[learning-engine] record_learning_event threw", err);
  }
}